import { ProgressEvent } from '../../../adapters';
import {
    ContentDuration,
    IContent,
    MediaControllerState,
    PlanetMediaPlayer,
    PlanetUserInteractionArgs,
    PlaybackSessionState,
    TimeSpan,
} from '../../../media-player';
import { VideoAnalyticsTrackerType } from './enums';
import { BrowserConsoleTrackerOptions } from './models';
import { PlaybackSessionTracker } from './playback-session-tracker';

export class BrowserConsoleTracker extends PlaybackSessionTracker<VideoAnalyticsTrackerType.BrowserConsole, BrowserConsoleTrackerOptions> {

    constructor() {
        super();
    }

    async setup(player: PlanetMediaPlayer, options: BrowserConsoleTrackerOptions): Promise<BrowserConsoleTracker> {
        await super.setup(player, options);
        return this;
    }

    trackSeek(position: number): void {
        console.log('seeked', position);
    }

    trackContentLoad(content: IContent, index: number): void {
        console.log('content load', `[${index}]${content.title}`);
    }

    trackPlaybackStart(position: number, duration: ContentDuration): void {
        console.log('playback start at', {position, duration});
    }

    trackPlaybackPause(position: number, duration: ContentDuration, state: MediaControllerState, played: TimeSpan): void {
        console.log('playback stop at', {
            position,
            duration,
            played,
        });
    }

    onUserInteraction(event: PlanetUserInteractionArgs): void {
        console.log('user interaction', {event});
    }

    trackPlaybackComplete(): void {
        console.log('playback complete');
    }

    dispose(): void {
    }

    onError(error: Error): void {
        console.warn('[BrowserConsoleTracker] Error', error.message);
    }

    onSetupError(setupError: Error): void {
        console.warn('[BrowserConsoleTracker] Setup Error', setupError.message);
    }

    trackPlaybackResume(position: number, duration: ContentDuration) {
        console.log('playback session resume');
    }

    trackSessionEnd(session: PlaybackSessionState): void {
        console.log('playback session end');
    }

    trackSessionCreate(session: PlaybackSessionState): void {
        console.log('playback session create');
    }

    trackStateChange(oldState: MediaControllerState, newState: MediaControllerState): void {
        console.log('state changed', oldState, '->', newState);
    }

    onBufferChange(data: ProgressEvent): void {
    }
}
